<header fxLayout="row" fxLayoutAlign="space-between center" class="header-container">
    <!-- Left Side: Title & Welcome Subtitle -->
    <div fxLayout="column" fxLayoutAlign="center start" class="header-left-side">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" class="title-row">
            <!-- Hamburger Menu for Mobile -->
            <button mat-icon-button class="mobile-menu-btn" (click)="onToggleSidebar()">
                <mat-icon class="menu-icon">menu</mat-icon>
            </button>
            <button *ngIf="pageTitle !== 'Dashboard'" mat-icon-button (click)="goBack()" class="back-button">
                <mat-icon class="back-icon">arrow_back</mat-icon>
            </button>
            <h1 class="header-title">{{pageTitle}}</h1>
            <span *ngIf="isReadOnly$ | async" class="view-only-badge" matTooltip="Read-Only Mode: All data modifications are disabled.">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle;">visibility</mat-icon> View Only
            </span>
        </div>
        <span *ngIf="pageTitle === 'Dashboard'" class="welcome-text">{{'dashboard.welcome'|translate}} {{userAuthinfo?.Name}}
            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp; {{todayDate | date:'EEEE, d MMM y'}}</span>
    </div>

    <!-- Right Side: Switcher, Notifications, Profile -->
    <div fxLayout="row" fxLayoutAlign="end center" class="right-header-container">

        <!-- Company Dropdown -->
        <!-- <div class="profile-wrapper" *ngIf="this.userAuthinfo?.role?.id == 1" [matMenuTriggerFor]="companyMenu" fxLayoutGap="20px">
            <button mat-button class="company-switcher">
            
                <span class="company-name">
                    {{ selectedCompanyName || 'Select Company' }}
                </span>
            
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
            
            <mat-menu #companyMenu="matMenu" class="company-menu">
                <button mat-menu-item *ngFor="let company of companyList" (click)="selectCompany(company,'dropdown')">
            
                    {{ company.company_name }}
                </button>
            </mat-menu>
        </div> -->

        <!-- autocomplete -->
        <!-- <div class="company-wrapper" *ngIf="userAuthinfo?.role?.id == 1">
        
            <mat-form-field appearance="outline" class="company-search-field">
        
                <input type="text" matInput placeholder="Search Company" [(ngModel)]="companySearchText"
                    (ngModelChange)="onCompanySearch($event)" [matAutocomplete]="auto">
        
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCompany($event.option.value,'search')">
        
                    <mat-option *ngFor="let company of companyList" [value]="company">
                        {{ company.company_name }}
                    </mat-option>
        
                    <mat-option *ngIf="isLoading" disabled>
                        Loading...
                    </mat-option>
        
                </mat-autocomplete>
        
            </mat-form-field>
        
        </div> -->

        <!-- dropdown searcable -->
        <!-- <div class="profile-wrapper" *ngIf="userAuthinfo?.role?.id == 1" [matMenuTriggerFor]="companyMenu">
        
            <button mat-button class="company-switcher">
                <span class="company-name">
                    {{ selectedCompanyName || 'Select Company' }}
                </span>
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
        
            <mat-menu #companyMenu="matMenu" class="company-menu">
            
                <div class="menu-search-box" (click)="$event.stopPropagation()">
                    <input matInput placeholder="Search company..." [(ngModel)]="companySearchText"
                        (ngModelChange)="filterCompanies()" class="menu-search-input" />
                </div>
            
                <mat-divider></mat-divider>
            
                <button mat-menu-item *ngFor="let company of filteredCompanyList" (click)="selectCompany(company,'dropdown')">
                
                    {{ company.company_name }}
                </button>
            
                <div *ngIf="filteredCompanyList.length === 0" class="no-result">
                    No company found
                </div>
            
            </mat-menu>
        
        </div> -->

        <!-- approach 1 start -->
        <div class="profile-wrapper" *ngIf="show_company_dropdown() && !this.is_multiple_gc_user"
            [matMenuTriggerFor]="isEditMode ? null : companyMenu" [style.cursor]="isEditMode ? 'not-allowed' : 'pointer'">

            <button mat-button class="company-switcher" [disabled]="isEditMode" [style.cursor]="isEditMode ? 'not-allowed' : 'pointer'">
                <span class="company-name" [attr.title]="selectedCompanyName || 'Select Company'">
                    {{ selectedCompanyName || 'Select Company' }}
                </span>
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>

            <mat-menu #companyMenu="matMenu" class="company-menu" (menuOpened)="onCompanyMenuOpen()">

                <!-- 🔍 SEARCH BOX (Sticky + Focusable) -->
                <div class="menu-search-box" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">

                    <mat-icon class="search-icon">search</mat-icon>

                    <input #companySearchInput matInput placeholder="Search company..." [(ngModel)]="companySearchText"
                        (ngModelChange)="filterCompanies()" class="menu-search-input" />

                    <!-- ❌ Clear Search -->
                    <mat-icon class="clear-icon" (click)="clearSearch($event)">
                        close
                    </mat-icon>

                </div>

                <mat-divider></mat-divider>

                <!-- Default Select Option -->
                <!-- <button mat-menu-item *ngIf="!this.is_multiple_gc_user" (click)="clearCompany()">
                        - Default Company -
                    </button> -->

                <!-- Company List -->
                <button mat-menu-item *ngFor="let company of filteredCompanyList"
                    (click)="selectCompany(company,'dropdown');onSwitchUser($event, company.id)">
                    {{ company.company_name }}
                </button>

                <div *ngIf="filteredCompanyList.length === 0" class="no-result">
                    No company found
                </div>

            </mat-menu>
        </div>

        <!-- approach 1 end-->

        <!-- Modal Trigger specifically for Role 3 multiple GC Users -->
        <div class="profile-wrapper"
            *ngIf="userAuthinfo?.role?.id == 3 && is_multiple_gc_user && gc_user_list.length > 0"
            [style.cursor]="isEditMode ? 'not-allowed' : 'pointer'">
            <button mat-button class="company-switcher" [disabled]="isEditMode" (click)="isEditMode ? null : openCompanySwitcherModal()" [style.cursor]="isEditMode ? 'not-allowed' : 'pointer'">
                <span class="company-name" [attr.title]="selectedCompanyName || 'Select Company'">
                    {{ selectedCompanyName || 'Select Company' }}
                </span>
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
        </div>



        <!---------notification------------->
        <!-------user button -------->
        <div class="profile-wrapper" routerLink="/notification" style="cursor: pointer;">
            <button class="my-fab" mat-mini-fab aria-label="Example icon button with a filter list icon">
                <mat-icon class="material-icons notification-icon" [matBadge]="count" [matBadgeHidden]="!count || count === '0'"
                    (click)="toggleBadgeVisibility()" matBadgeColor="warn">notifications </mat-icon><span
                    class="cdk-visually-hidden"></span>
            </button>
        </div>

        <!-------user button -------->
        <div class="profile-wrapper" routerLink="/profile/my-profile" style="cursor: pointer;">
            <button class="my-fab" mat-mini-fab aria-label="Profile Settings">
                <span class="profile-initials">{{first}}{{last}}</span>
            </button>
        </div>

    </div>
</header>
<app-company-switcher *ngIf="showCompanySwitcher" [companies]="gc_user_list"
    (companySelected)="handleCompanySelection($event)" (cancel)="showCompanySwitcher = false"></app-company-switcher>
